import PageRoutes from "./routes/PageRoutes";
import {UserProvider} from "./core/providers";

function App() {

    return (
        <UserProvider>
            <PageRoutes/>
        </UserProvider>
    );
}

export default App;
